import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex px-4 flex-wrap"
}
const _hoisted_2 = ["value", "id"]
const _hoisted_3 = ["for"]

import { LAYER_TYPES }  from '@/grapql/assetsComparisonCriteriaOptions';
import { useQuery } from '@vue/apollo-composable';
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

export interface LayerTypeInterface {
    id: number, 
    name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TechnologyAssetsFilterByLayerType',
  setup(__props) {

const store = useStore();
const { result } = useQuery(LAYER_TYPES);
const queryResult = computed(() => result?.value ?? null);
const layerTypes = computed<LayerTypeInterface[]>(() => queryResult.value && queryResult.value.layerTypes.edges.length ? queryResult.value.layerTypes.edges.map((edge) => edge.node) : null)

const selectedLayerType = ref([]);

const setValueInStore = () => store.commit('assetsModule/setSelectedLayerTypeForFilter', selectedLayerType.value );

onMounted(() => {
    const statusFromStore = store.state.assetsModule.selectedLayerTypeForFilter;
    selectedLayerType.value = statusFromStore
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center pl-4 mb-4" }, [
      _createElementVNode("p", null, "Select assets by layer functionality: ")
    ], -1)),
    (layerTypes.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layerTypes.value, (layer) => {
            return (_openBlock(), _createElementBlock("div", {
              key: layer.id
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLayerType).value = $event)),
                onChange: setValueInStore,
                value: layer.name,
                id: layer.name,
                class: "hidden peer"
              }, null, 40, _hoisted_2), [
                [_vModelCheckbox, selectedLayerType.value]
              ]),
              _createElementVNode("label", {
                for: layer.name,
                class: "transition-colors duration-200 ease-in-out peer-checked:bg-red-300 peer-checked:text-white cursor-pointer border m-1 px-3 py-2 rounded-lg"
              }, _toDisplayString(layer.name), 9, _hoisted_3)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})